import { useQuery } from '@tanstack/react-query';
import { fetchCardsByIds } from '../api/cards';
import { CardSummary } from '../types/cards';

/**
 * 카드 ID 배열로 카드 정보를 가져오는 훅
 */
export function useCards(cardIds: number[], enabled: boolean = true) {
  return useQuery<CardSummary[]>({
    queryKey: ['cards', cardIds.sort().join(',')],
    queryFn: () => fetchCardsByIds(cardIds),
    enabled: enabled && cardIds.length > 0,
    staleTime: 1000 * 60 * 5, // 5분
  });
}

